import { apiClient } from "shared/api/client";
import { alertDialog } from "shared/ui/feedback";

const normalizeListResponse = (data) => {
  let list = [];
  if (Array.isArray(data)) {
    list = data;
  } else if (Array.isArray(data?.content)) {
    list = data.content;
  } else if (Array.isArray(data?.data)) {
    list = data.data;
  }

  const totalCandidates = [
    data?.totalElements,
    data?.total,
    data?.count,
    data?.page?.totalElements,
    data?.meta?.total,
    data?.pagination?.total,
  ];
  const normalizedTotal = totalCandidates.find(
    (value) => Number.isInteger(value) && value >= 0
  );

  if (normalizedTotal !== undefined) {
    Object.defineProperty(list, "__total", {
      value: normalizedTotal,
      enumerable: false,
      configurable: true,
    });
  }

  return list;
};

export const getInquiries = async () => {
  try {
    const response = await apiClient.get("/inquiries");
    const Inquiries = normalizeListResponse(response.data);
    return Inquiries;
  } catch (error) {
    window.location.assign("/login");
    alertDialog("로그인이 필요합니다.");
    // console.error("Error in getInquiries:", error);
    throw error;
  }
};

export const getSuggests = async () => {
  const response = await apiClient.get("/suggests");
  return normalizeListResponse(response.data);
};

// 소통(문의/제안) 목록·상세 공통 — detailPath는 "inquiries" | "suggests"
export const getCommunicationList = async (path) => {
  const response = await apiClient.get(path);
  return response.data;
};

export const getCommunicationDetail = async (detailPath, id) => {
  const response = await apiClient.get(`/${detailPath}/${id}`);
  return response.data;
};

export const deleteCommunication = async (detailPath, id) => {
  await apiClient.delete(`/${detailPath}/${id}`);
};

export const updateCommunicationStatus = async (detailPath, id, status) => {
  await apiClient.patch(`/${detailPath}/${id}/status`, { status });
};

export const answerCommunication = async (detailPath, id, payload) => {
  await apiClient.patch(`/${detailPath}/${id}/answer`, payload);
};
